module.exports = __webpack_public_path__ + "img/350.481bda49.png";